export default {
  //Getter 接受 state 作为其第一个参数：
  doneTodos: (state) => {
    return state.todos.filter((todo) => todo.done);
  },
  // 你也可以通过让 getter 返回一个函数，来实现给 getter 传参。在你对 store 里的数组进行查询时非常有用。
  getTodoById: (state) => (id) => {
    return state.todos.find((todo) => todo.id === id);
  },
};
